import React from 'react';
import { View, StyleSheet } from 'react-native';
import { SkeletonBone } from '../SkeletonBone';
import { SkeletonCircle } from '../SkeletonCircle';

interface SkeletonListItemProps {
  avatar?: boolean;
  avatarSize?: number;
  lines?: number;
  lineWidths?: (number | `${number}%`)[];
  lineHeight?: number;
  gap?: number;
}

export const SkeletonListItem: React.FC<SkeletonListItemProps> = React.memo(({
  avatar = true,
  avatarSize = 40,
  lines = 2,
  lineWidths,
  lineHeight = 14,
  gap = 6,
}) => (
  <View style={styles.row}>
    {avatar && <SkeletonCircle size={avatarSize} />}
    <View style={[styles.textColumn, { gap }]}>
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBone
          key={i}
          width={lineWidths?.[i] ?? (i === 0 ? 140 : 100)}
          height={lineHeight}
        />
      ))}
    </View>
  </View>
));

SkeletonListItem.displayName = 'SkeletonListItem';

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  textColumn: {
    flex: 1,
  },
});
